//@flow
import React from 'react'
//$FlowFixMe
import css from './slider-style.module.scss'
type Props = {
  width: number,
  radius: number,
  rangeMin: number,
  rangeMax: number,
  value: number,
  strokeWidth: number,
  onSeek: Function
}
export default class CircleSlider extends React.Component<Props> {

  static defaultProps:Object  = {
    width: 100,
    radius: 90,
    rangeMin: 0,
    rangeMax: 100,
    value: 0,
    strokeWidth: 16
  }

  constructor(props:Object){
    super(props)
    this.controlRef = React.createRef()
  }
  controlRef: Object;
  mousedown:bool = false;

  handleMouseUp(e: SyntheticMouseEvent<*>) {
    this.mousedown = false
    e.stopPropagation()
    e.preventDefault()
  }

  handleMouseDown(e: SyntheticMouseEvent<*>) {
    this.mousedown = true
    e.stopPropagation()
    e.preventDefault()
    this.calculateSeekedValue(e);
  };

  handleMouseMove(e: SyntheticMouseEvent<*>) {
    e.stopPropagation()
    e.preventDefault()
    if (this.mousedown) {
      e.preventDefault()
      this.calculateSeekedValue(e);
    }
  };

  handleTouchStart(e: SyntheticTouchEvent<*>) {
    e.stopPropagation()
    e.preventDefault()
    this.mousedown = true
  }

  handleTouchEnd(e: SyntheticTouchEvent<*>) {
    this.mousedown = false
    e.stopPropagation()
    e.preventDefault()
  }

  handleClick(e: SyntheticMouseEvent<*>) {
    // this.props.onClick(e)
  }

  // handleInput(e : SyntheticInputEvent < * >) {
  //    this.props.onSeek(Number(e.target.value));
  // }

  render():Object  {

    const value = this.props.value || 0;

    // console.log('Value: ', value);

    var progress = value / this.props.rangeMax;
    var dashoffset = 2 * Math.PI * (this.props.radius - this.props.strokeWidth / 2) * (1 - progress);
    // console.log('dashoffset: ' + dashoffset);
    const style = {
      strokeDasharray: 2 * Math.PI * (this.props.radius - this.props.strokeWidth / 2),
      strokeDashoffset: dashoffset || 0,
      stroke: "#c3478c"
    };

    return <div className={css.sliderContainer} onClick={(e) => this.handleClick(e)}>
      <svg ref={this.controlRef} onMouseUp={(e) => this.handleMouseUp(e)} onTouchEnd={(e) => this.handleTouchEnd(e)} onMouseMove={(e) => this.handleMouseMove(e)} onTouchMove={(e) => this.handleMouseMove(e)} className={css.progress} width={200} height={200} viewBox={`0 0 ${200} ${200}`} xmlns="http://www.w3.org/2000/svg">
        <g onTouchStart={(e) => this.handleTouchStart(e)} onMouseDown={(e) => this.handleMouseDown(e)}>
          <circle className={css.progressMeter} cx={this.props.width} cy={this.props.width} r={this.props.radius - this.props.strokeWidth / 2} strokeWidth={this.props.strokeWidth}></circle>
          <circle style={style} className={css.progressValue} cx={this.props.width} cy={this.props.width} r={this.props.radius - this.props.strokeWidth / 2} strokeWidth={this.props.strokeWidth}></circle>
        </g>
      </svg>
    </div>

  }

  calculateSeekedValue(e: SyntheticMouseEvent<*>) {

    let frame = this.controlRef.current && this.controlRef.current.getBoundingClientRect();
    if (!frame)
      return

    let x = 0;
    let y = 0;

    if (e.type === "mouseup" || e.type === "mousedown" || e.type === "mousemove" || e.type === "click") {

      y = (e.clientX - frame.x - frame.width / 2) / this.props.radius;
      x = -1 * (e.clientY - frame.y - frame.height / 2) / this.props.radius;
    }

    if (e.type === "touchend" || e.type === "touchstart" || e.type === "touchmove") {
      e.preventDefault();
      // $FlowFixMe
      y = (e.touches[0].clientX - frame.x - frame.width / 2) / this.props.radius;
      // $FlowFixMe
      x = -1 * (e.touches[0].clientY - frame.y - frame.height / 2) / this.props.radius;
    }

    // angle in radians
    let p = Math.atan2(y, x);

    //if second quadrant
    if (y < 0)
      p += 2 * Math.PI

    p = p / (2 * Math.PI)
    // console.log(x, y, this.props.rangeMax, p);

    if (this.props.rangeMax !== Infinity)
      this.props.onSeek(this.props.rangeMax * p)
  };

}
